// extracted by mini-css-extract-plugin
export default {"archiveWarning":"TiVoAppRowMenu__archiveWarning-_uKAE"};